import { render, staticRenderFns } from "./ShippoAddressStreet.vue?vue&type=template&id=66efb5b8&"
import script from "./ShippoAddressStreet.vue?vue&type=script&lang=ts&"
export * from "./ShippoAddressStreet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports